import { Card, InputNumber, Form } from "antd"
import GeoPickerElement from "components/geoPicker"

type Props = {
  providerName: string;
  sampleRateName: string;
  whitelistedCountriesName: string;
};

export const SettingsSection = ({
  providerName,
  sampleRateName,
  whitelistedCountriesName,
}: Props) => {
  return (
    <Card title={`${providerName} Analytics`}>
      <Form.Item name={sampleRateName} label={`${providerName} Sample Rate (0-1)`}>
        <InputNumber min={0} max={1} step={0.01} />
      </Form.Item>

      <GeoPickerElement
        label={`${providerName} Whitelisted Countries`}
        name={whitelistedCountriesName}
        withGlobal
      />
    </Card>
  )
}
